module.exports = __webpack_public_path__ + "img/1fd590a687f78fdf3d9d55016fcbacf6.svg";